<template>
  <div class="asd20-file-filters">
    <asd20-viewport scrollable>
      <asd20-accordion
        v-for="(group, index) in groupedCategoryOptions"
        :key="index"
        :label="group.text"
        :badge="group.count"
        expanded
        tag="h3"
      >
        <asd20-checkbox-list
          :options="group.categories"
          :checked-values="selectedCategories"
          @input="selectedCategories = $event"
        />
      </asd20-accordion>

      <asd20-accordion
        v-if="isAuthenticated"
        heading="Owners"
        expanded
        scrollable
      >
        <asd20-checkbox-list
          :options="ownersOptions"
          :checked-values="selectedOwners"
          @input="selectedOwners = $event"
        />
      </asd20-accordion>
      <asd20-accordion

        heading="Organizations"
        expanded
        scrollable
      >
        <asd20-checkbox-list
          :options="organizationOptions"
          :checked-values="selectedOrganizationIds"
          @input="selectedOrganizationIds = $event"
        />
      </asd20-accordion>
    </asd20-viewport>
  </div>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import Asd20CheckboxList from '@asd20/ui/src/components/molecules/Asd20CheckboxList'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20Accordion from '@asd20/ui/src/components/molecules/Asd20Accordion'

export default {
  name: 'Asd20FileFilters',
  components: {
    Asd20CheckboxList,
    Asd20Viewport,
    Asd20Accordion,
  },
  props: {},

  computed: {
    selectedCategories: sync('files/selectedCategories'),
    isAuthenticated: get('auth/isAuthenticated'),
    categoryOptions: get('files/categoryOptions'),
    owners: get('files/owners'),
    selectedOwners: sync('files/selectedOwners'),
    ownersOptions: get('files/ownersOptions'),
    groupedCategoryOptions: get('files/groupedCategoryOptions'),
    organizations: get('orgs/organizations'),
    organizationOptions: get('files/organizationOptions'),
    selectedOrganizationIds: sync('files/selectedOrganizationIds'),
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';
.asd20-file-filters{
  label{
    margin: 0 space(1);
  }
}
.asd20-file-filters {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;

  .asd20-viewport {
    // padding-top: space(1);
    margin-bottom: auto;
    flex-grow: 0;
  }

  .asd20-checkbox-list {
    // padding-top: space(0.25);
    // padding-bottom: space(0.25);
    padding: 0 space(0.5);
  }

  .asd20-checkbox {
    padding-left: space(0.5);
    // padding-right: space(1);
  }
}
</style>
